import { CaptionStyles, CaptionLineConfig } from '../../types/asset-types';
import { getFontFullPath } from '../../utils/fontUtils';
import { TransitionInEffect } from '../../types/transitions';

const simpleBold: Partial<CaptionStyles> = {
  theme_preset: 'simpleBold',
  pageStyle: {
    color: '#ffffff',
    textShadow: '7px 10px 18px #000000'
  },
  wordStyle: undefined,
  letterStyle: undefined,
  font_location: getFontFullPath('Coda-ExtraBold.ttf'),
  caps: true,
  line_config: CaptionLineConfig.TwoLines,
  font_size: 72,
  transitions: {
    pageIn: TransitionInEffect.SlideUp
  }
};

export default simpleBold;
